import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import ProtectedRoute from '../../system/components/ProtectedRoute';
import { UserRoles } from '../../system/types';

// Import des routes de chaque module
import PersonneMoraleRoutes from './PersonneMorale/routes';
import ClubRoutes from './Club/routes';
import CommandeRoutes from './Commande/routes';
import FactureRoutes from './Facture/routes';
import FournisseurRoutes from './Fournisseur/routes';
import MandatRoutes from './Mandat/routes';
import ParrainageRoutes from './Parrainage/routes';
import PersonnePhysiqueRoutes from './PersonnePhysique/routes';
import CollaborateurRoutes from './Collaborateur/routes';
import RistourneRoutes from './Ristourne/routes';

// Définition des permissions requises pour chaque module
const modulePermissions: Record<string, UserRoles[]> = {
    PersonneMorale: ['ADMIN', 'USER'],
    Club: ['ADMIN', 'USER'],
    Commande: ['ADMIN', 'USER'],
    Facture: ['ADMIN', 'USER'],
    Fournisseur: ['ADMIN', 'USER'],
    Mandat: ['ADMIN', 'USER'],
    Parrainage: ['ADMIN', 'USER'],
    PersonnePhysique: ['ADMIN', 'USER'],
    Collaborateur: ['ADMIN', 'USER'],
    Ristourne: ['ADMIN', 'USER'],
    PotentielsParrainages: ['ADMIN', 'USER', 'COLLABORATEUR'],
    PotentielsParrainagesModifie: ['ADMIN', 'USER'],
};

/**
 * Centralise les routes de la section "data"
 * Tous les modules s'enregistrent ici automatiquement
 */
const DataRoutes: React.FC = () => {
    // Fonction pour wrapper les routes de chaque module avec ProtectedRoute
    const protectRoutes = (
        routes: React.ReactElement[],
        requiredRoles: UserRoles[]
    ) => {
        return routes.map((route, index) => {
            // Cloner la route existante avec ses props
            return (
                <Route
                    key={`protected-${index}`}
                    path={route.props.path}
                    element={
                        <ProtectedRoute requiredRoles={requiredRoles}>
                            {route.props.element}
                        </ProtectedRoute>
                    }
                />
            );
        });
    };

    // Combinaison des routes protégées
    const allModuleRoutes = [
        ...protectRoutes(
            PersonneMoraleRoutes,
            modulePermissions.PersonneMorale
        ),
        ...protectRoutes(ClubRoutes, modulePermissions.Club),
        ...protectRoutes(CommandeRoutes, modulePermissions.Commande),
        ...protectRoutes(FactureRoutes, modulePermissions.Facture),
        ...protectRoutes(FournisseurRoutes, modulePermissions.Fournisseur),
        ...protectRoutes(MandatRoutes, modulePermissions.Mandat),
        ...protectRoutes(ParrainageRoutes, modulePermissions.Parrainage),
        ...protectRoutes(
            PersonnePhysiqueRoutes,
            modulePermissions.PersonnePhysique
        ),
        ...protectRoutes(CollaborateurRoutes, modulePermissions.Collaborateur),
        ...protectRoutes(RistourneRoutes, modulePermissions.Ristourne),
    ];

    return <Routes>{allModuleRoutes}</Routes>;
};

export default DataRoutes;
